import script from "./Head.vue?vue&type=script&setup=true&lang=js"
export * from "./Head.vue?vue&type=script&setup=true&lang=js"

import "./Head.vue?vue&type=style&index=0&id=12bd89c4&lang=css"

const __exports__ = script;

export default __exports__